import React from 'react';
import { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import "./App.css";
import Header from './header';
import MobileHeader from './mobileHeader';
import Main from './Main';
import Features from './Features';
import Extension from './Extension';
import FAQ from "./FAQ";
import Form from './Form';
import Footer from './Footer';

const App = () => {
   const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener when component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
     return (
      <>
        {windowWidth <= 650 ? <MobileHeader /> : <Header />}
        <Main />
        <Features />
        <Extension />
        <FAQ />
        <Form />
        <Footer />
      </>       
     );
};

export default App;